var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContractmenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.449,
    height: 28.725,
    viewBox: "0 0 28.449 28.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_428",
    "data-name": "Group 428",
    transform: "translate(-57.054 -138.086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M85.5,147.77c-.533.916-1.069,1.831-1.6,2.748q-1.9,3.291-3.8,6.584c-.215.372-.42.75-.643,1.118a.6.6,0,0,0-.063.343q0,3.095,0,6.19a1.935,1.935,0,0,1-2.046,2.056c-1.311,0-2.623,0-3.934,0a.827.827,0,0,1-.831-1.112.856.856,0,0,1,.874-.536q1.912,0,3.824,0c.4,0,.463-.063.463-.461q0-1.6,0-3.191V161.3c-.353.691-1.065.941-1.63,1.354-.82.6-1.678,1.148-2.515,1.724a.85.85,0,0,1-1.408-.8c.112-1.452.221-2.9.334-4.356a2.923,2.923,0,0,1,.459-1.017c.043-.088.161-.17.116-.261s-.182-.04-.277-.04q-5.2,0-10.4,0a.823.823,0,0,1-.924-.6.808.808,0,0,1,.72-1.041c.1-.01.2-.005.3-.005q5.64,0,11.279.006a.471.471,0,0,0,.476-.266q1.677-2.93,3.37-5.851a.685.685,0,0,0,.1-.361q0-4.814,0-9.629c0-.326-.077-.4-.4-.4H59.128c-.348,0-.421.071-.421.415q0,9.766,0,19.533c0,.2.046.266.257.264.954-.012,1.907-.007,2.861,0a1.962,1.962,0,0,1,2.094,2.078c.007.944.009,1.889,0,2.834,0,.234.048.311.3.309,1.375-.013,2.751-.01,4.126,0a.816.816,0,0,1,.822,1.135.754.754,0,0,1-.746.509c-1.779.009-3.558.006-5.337,0a.853.853,0,0,1-.611-.274q-2.567-2.569-5.135-5.136a.993.993,0,0,1-.274-.751q0-4.4,0-8.8,0-5.832,0-11.664a1.942,1.942,0,0,1,2.092-2.092H77.3a1.942,1.942,0,0,1,2.091,2.093q0,3.384,0,6.768c0,.018,0,.036.013.12.226-.384.427-.723.625-1.062s.374-.673.582-1a2.8,2.8,0,0,1,4.7-.028c.059.089.092.2.191.258Zm-4.876.506c-.737,1.274-1.462,2.524-2.184,3.775q-1.933,3.351-3.867,6.7c-.073.126-.066.177.059.248.558.315,1.113.633,1.663.962.159.1.221.06.308-.094.567-1,1.145-2,1.722-3q2.088-3.61,4.181-7.217c.106-.182.067-.263-.105-.359C81.81,148.965,81.227,148.622,80.626,148.277Zm3.5-1.759a1.173,1.173,0,0,0-.83-1.108,1.157,1.157,0,0,0-1.308.511c-.152.25-.284.512-.444.756-.094.144-.046.2.082.27.415.232.822.477,1.234.714.19.109.407.322.57.288.191-.04.245-.355.365-.546A1.522,1.522,0,0,0,84.126,146.518Zm-21.86,17.417c0-.645,0-1.286,0-1.927,0-.218-.06-.4-.3-.407-.681-.013-1.363,0-2.036,0Zm12.98-2.685-1.168-.665-.115,1.545Z",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M143.919,357.63q-2.914,0-5.828,0a.849.849,0,0,1-.882-.52.82.82,0,0,1,.7-1.125,1.385,1.385,0,0,1,.165-.005h11.683a.837.837,0,0,1,.872.533.817.817,0,0,1-.8,1.115c-.458.013-.916,0-1.374,0Z",
    transform: "translate(-75.69 -205.899)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M143.931,243.975q2.916,0,5.832,0a.846.846,0,0,1,.877.527.828.828,0,0,1-.738,1.121c-.055,0-.11,0-.165,0H138.128a.881.881,0,0,1-.9-.532.818.818,0,0,1,.766-1.117c.091,0,.183,0,.275,0Z",
    transform: "translate(-75.707 -100.06)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M205.088,411.93h4.151a.826.826,0,0,1,.684,1.341.9.9,0,0,1-.784.311H201.5c-.22,0-.441.011-.66-.005a.82.82,0,0,1-.8-.846.8.8,0,0,1,.842-.8c.788-.009,1.576,0,2.364,0Z",
    transform: "translate(-135.115 -258.769)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M140.288,301.637h-2.394a.83.83,0,0,1-.8-.485.821.821,0,0,1,.748-1.164c1.623,0,3.246-.006,4.869,0a.838.838,0,0,1,.843.807.847.847,0,0,1-.874.838C141.883,301.643,141.085,301.637,140.288,301.637Z",
    transform: "translate(-75.557 -152.988)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M193.984,525.555c-.779,0-1.559,0-2.338,0a.825.825,0,1,1-.006-1.648c1.568,0,3.136,0,4.7,0a.823.823,0,1,1,.006,1.646C195.561,525.562,194.772,525.555,193.984,525.555Z",
    transform: "translate(-126.364 -364.581)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M280.39,299.984c.688,0,1.375,0,2.063,0a.82.82,0,0,1,.489,1.5.869.869,0,0,1-.545.152c-1.33,0-2.659,0-3.989,0a.828.828,0,1,1,0-1.649C279.07,299.981,279.73,299.983,280.39,299.984Z",
    transform: "translate(-208.313 -152.985)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M138.35,411.939c.146,0,.293,0,.439,0a.808.808,0,0,1,.828.781.8.8,0,0,1-.77.862,7.141,7.141,0,0,1-.987,0,.821.821,0,0,1,.051-1.641C138.057,411.935,138.2,411.939,138.35,411.939Z",
    transform: "translate(-75.619 -258.778)",
    fill: "#c5c6c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M293.969,629.934a.824.824,0,0,1-.027,1.648.824.824,0,1,1,.027-1.648Z",
    transform: "translate(-223.077 -464.775)",
    fill: "#c5c6c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractmenu);
export default __webpack_public_path__ + "static/media/contractmenu.ab504fdc306811e1a7998224c179380f.svg";
export { ForwardRef as ReactComponent };